import { Injectable } from '@angular/core';

import { UrlConstant } from './partials/url.constant';
import { DataTableConstant } from './partials/data-table.constant';
import { LanguagesConstant } from './partials/languages.constant';
import { FlightAlertsConstant } from './partials/flight-alerts.constant';
import { CabinClassesConstant } from './partials/cabin-classes.constant';
import { SearchCriteriaConstant } from './partials/search-criteria.constant';
import { PaginationConstant } from './partials/pagination.constant';
import { JourneyTypesConstant } from './partials/journey-types.constant';

@Injectable()
export class GlobalConstant {
  public url: UrlConstant = new UrlConstant();
  public dataTable: DataTableConstant = new DataTableConstant();
  public languages: LanguagesConstant = new LanguagesConstant();
  public flightAlerts: FlightAlertsConstant = new FlightAlertsConstant();
  public cabinClassesConstant: CabinClassesConstant = new CabinClassesConstant();
  public searchCriteria: SearchCriteriaConstant = new SearchCriteriaConstant();
  public pagination: PaginationConstant = new PaginationConstant();
  public journeyTypes: JourneyTypesConstant = new JourneyTypesConstant();
}
